import { getCurrentInstance } from 'vue';

export function useSanitize() {
  const instance = getCurrentInstance();
  const sanitize = (value?: string) => {
    if (!instance?.appContext.app.config.globalProperties.$sanitize) {
      console.warn('Sanitize not available. Ensure vue-3-sanitize is installed with app.use(Vue3Sanitize)');
      return value ?? '';
    }
    return instance.appContext.app.config.globalProperties.$sanitize(value ?? '');
  };

  return { sanitize };
}
